import { render, staticRenderFns } from "./Index_m.vue?vue&type=template&id=529b9428&scoped=true"
import script from "./Index_m.vue?vue&type=script&lang=js"
export * from "./Index_m.vue?vue&type=script&lang=js"
import style0 from "./Index_m.vue?vue&type=style&index=0&id=529b9428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529b9428",
  null
  
)

export default component.exports